import { combineReducers } from 'redux'
import loginReducer from '../../containers/Login/Login.reducer'

export default combineReducers({
  login: loginReducer
})
